import React, { useState, useEffect } from "react";
import Tooltip from "antd/lib/tooltip";
import CaretDownFilled from "@ant-design/icons/CaretDownFilled";
import CaretUpFilled from "@ant-design/icons/CaretUpFilled";

import { useDispatch, useSelector } from "react-redux";
import HighCharts from "../../utils/charts/HighCharts/index";
import { setOptionHighChart } from "../../../redux/actions/HighChart";
import somethingWentWrong from "../../../assets/No_Data_Found.svg";
import { simpleKFormatterOnly } from "../../../redux/constants";

const KpiClickableWidget = ({
  preview,
  single,
  style,
  metadata,
  section_index,
  widget_index,
}) => {
  const dispatch = useDispatch();
  const [graphData, setGraphData] = useState({});
  const [graphLoader, setGraphLoader] = useState(false);
  const opData = useSelector((state) => state.Highchart.Options);
  let opDataWidget_id =
    metadata?.widget_id +
    (section_index >= 0 ? section_index : 0) +
    widget_index;

  useEffect(() => {
    if (Object.keys(graphData).length === 0) {
      setGraphData({
        id: opDataWidget_id + (metadata?.kpi_id ? metadata?.kpi_id : 0),
        data: single?.[metadata?.kpi_id ? metadata?.kpi_id : 0]?.line,
      });
    }
  }, [single]);

  useEffect(() => {
    const timerLoader = setTimeout(() => {
      setGraphLoader(false);
    }, 0);
    return () => {
      clearTimeout(timerLoader);
    };
  }, [graphLoader]);

  const cardTabs = (el, id) => {
    setGraphLoader(true);
    if (graphData?.id !== opDataWidget_id + id) {
      if (graphData?.id && opData?.[graphData?.id]) {
        let updatedOption = { ...opData };
        delete updatedOption?.[graphData?.id];
        dispatch(setOptionHighChart(updatedOption));
      }
      metadata.kpi_id = id;
      setGraphData({ id: opDataWidget_id + id, data: el?.line });
    }
  };

  return (
    <div className={`row mt-15 mr-0 ml-0`}>
      <div className="col-12 col-md-3">
        {single &&
          single?.map((el, i) => {
            return (
              <div
                onClick={() => cardTabs(el, i)}
                className={`w-100 border-width-2 ticket_cardList ${
                  graphData?.id === opDataWidget_id + i
                    ? "border-blue"
                    : "border-color"
                } box-shadow border-radius-4 cursor-pointer border mb-15 p-2`}
                style={{
                  backgroundColor:
                    graphData?.id === opDataWidget_id + i
                      ? "rgb(169 192 232 / 30%)"
                      : "#fff",
                }}
              >
                <div
                  //   style={{
                  //     color: graphData?.id === "Ticket_" + i ? "#fff" : "",
                  //   }}
                  className="text_regular font-weight500 mb-1 line-height-normal"
                >
                  {el?.kpi?.text}
                </div>
                <div className="d-flex align-items-baseline">
                  <span
                    // style={{
                    //   color: graphData?.id === "Ticket_" + i ? "#fff" : "",
                    // }}
                    className={`wm-chart-card-value mr-1 font-weight400 line-height-normal`}
                  >
                    {simpleKFormatterOnly(el?.kpi?.value)}
                  </span>
                  {el?.kpi?.percent_change !== 0 && (
                    <span
                      className={`${
                        el?.kpi?.percent_change > 0
                          ? "positive"
                          : el?.kpi?.percent_change < 0 && "negative"
                      } text_regular font-weight500 mb-1 line-height-normal`}
                    >
                      {el?.kpi?.percent_change > 0 ? (
                        <CaretUpFilled className="font-size18" />
                      ) : (
                        el?.kpi?.percent_change < 0 && (
                          <CaretDownFilled className="font-size18" />
                        )
                      )}{" "}
                      {simpleKFormatterOnly(el?.kpi?.percent_change)}
                    </span>
                  )}
                </div>
              </div>
            );
          })}
      </div>

      <div className="col-12 col-md-9" style={{ height: `${style?.height}px` }}>
        {graphLoader ? (
          <div className="loader text-center w-100" style={{ height: "45rem" }}>
            <div className="lds-ring">
              <div></div>
              <div></div>
              <div></div>
              <div></div>
            </div>
          </div>
        ) : Array.isArray(graphData?.data) ? (
          <HighCharts
            single={graphData?.data}
            id={graphData?.id}
            style={style}
            type="line"
            metadata={metadata}
          />
        ) : (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: "45rem" }}
          >
            <div className="text-center">
              <img
                alt="no data"
                src={somethingWentWrong}
                style={{ maxWidth: "100%", minWidth: "20rem" }}
              />
              <p className="mt-15 text_regular-gray">No Data Found</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KpiClickableWidget;
